import React from 'react';

export default function CheckoutSuccess() {
  return <h3>Thank you for subscribing, start to create your app now! </h3>;
}
